import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import '@/styles/index.scss'
import router from './router';
import store from './store';
import colorTemplate from '@/service/template'
import "./vee-validate";
import VueScrollTo from 'vue-scrollto'
import 'vue2-datepicker/index.css';
import moment from "moment"
import momentTH from 'moment/src/locale/th'

import 'vue-swatches/dist/vue-swatches.css'
Vue.config.productionTip = false

Vue.filter("dateFomatShortmonth", function(date) {
  let res = '';
  if (typeof date === 'undefined' || date === null || date === '') {
    res = '-';
  } else {
    res = moment(moment(date).locale('th', momentTH).add(543,'y')).format('ll');
  }
  return res;
});

Vue.filter('dateTimeTh', (date) => {
  let res = '';
  if (typeof date === 'undefined' || date === null || date === '') {
    res = '-';
  } else {
    res = moment(moment(date).locale('th', momentTH).add(543,'y')).format('lll น.');
  }
  return res;
});

Vue.mixin(colorTemplate)
Vue.use(Buefy)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -50,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(require('vue-moment'));
Vue.use(momentTH);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
